import { API_BASE_URL } from "./API_CONSTANT";
import { Http } from "./axios/http";

export const downloadPDF = async (
  downloadUrl: string,
  fileName?: string,
  params?: any
) => {
  try {
    if (!downloadUrl) return;

    const isExternalUrl = /^https?:\/\//i.test(downloadUrl);

    if (isExternalUrl) {
      const a = document.createElement("a");

      a.href = downloadUrl;
      a.download = fileName || "document.pdf";
      a.target = "_blank";

      document.body.appendChild(a);
      a.click();
      a.remove();

      return;
    }

    const fullUrl = `${API_BASE_URL}${downloadUrl}`;

    const res = await Http.getFile(fullUrl, params);

    const blob = new Blob([res.data], {
      type: "application/pdf",
    });

    const url = URL.createObjectURL(blob);

    const providedName = res?.headers?.["content-disposition"]
      ?.split("filename=")?.[1]
      ?.replace(/"/g, "")
      ?.trim();

    const filename =
      providedName ||
      fileName ||
      "document.pdf";

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Erreur téléchargement PDF:", err);
  }
};